import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import RcsConversationPreviewImage from 'shared/assets/images/rcs/rcs_conversation_preview.png'
import { Avatar, Box, IconButton, Scrollbar, Typography } from 'shared/ui'
import { getCDNAssetURL } from 'shared/lib'
import { useSenderDetailsContext } from 'pages/settings/pages/rcsV2/pages/SenderDetails/hooks/useSenderDetailsContext'

import styles from './styles.module.scss'

export const RcsConversationPreview = observer(() => {
  const {
    brandInfoStore: { brandName },
    brandMediaStore: { logoUrl },
  } = useSenderDetailsContext()

  const messagesMock = [
    {
      id: 0,
      image: RcsConversationPreviewImage,
      isOutbound: true,
    },
    {
      id: 1,
      message:
        'Appointment reminder. Hi Dave, your appointment is scheduled for January 1 at 10 a.m. Please confirm your appointment or reschedule now.',
      isOutbound: true,
    },
    {
      id: 2,
      message: 'Confirm',
      isOutbound: false,
    },
    {
      id: 3,
      message: 'Great! Your appointment is confirmed for January 1 at 10 a.m.',
      isOutbound: true,
    },
  ]

  return (
    <div className={styles.preview}>
      <div className={styles.preview__layer}>
        <div className={styles.preview__layerWrap}>
          <Scrollbar>
            <Box
              display={'flex'}
              justifyContent={'space-between'}
              alignItems={'center'}
              className={styles.preview__headerWrap}
            >
              <div className={styles.preview__header}>
                <IconButton
                  color='tertiary'
                  variant='icon'
                  ariaLabel='back_to_lastStep'
                  icon='arrowLeft'
                  size='small'
                />
                <Avatar size={24} info={{ image: logoUrl }} />
                <Typography
                  ariaLabel='info_and_options'
                  variant='body-sm-medium'
                  color='var(--content-primary-primary)'
                  ellipsis
                  tooltipProps={{
                    label: brandName,
                    placement: 'top',
                  }}
                  width={120}
                >
                  {brandName}
                </Typography>
              </div>
              <IconButton
                color='tertiary'
                variant='icon'
                ariaLabel='back_to_lastStep'
                icon='moreVertical'
                size='small'
              />
            </Box>
            <div className={styles.preview__messages}>
              {messagesMock.map((message) => (
                <Box
                  key={message.id}
                  display={'flex'}
                  justifyContent={message.isOutbound ? 'flex-start' : 'flex-end'}
                >
                  <div
                    className={classNames(styles.preview__message, {
                      [styles.preview__messageOutbound]: message.isOutbound,
                      [styles.preview__messageWithImage]: message.image,
                    })}
                  >
                    {message.message && (
                      <Typography
                        ariaLabel='message'
                        variant='body-md-regular'
                        color='var(--content-primary-primary)'
                      >
                        {message.message}
                      </Typography>
                    )}
                    {message.image && (
                      <img src={getCDNAssetURL(message.image)} alt='conversation-preview' />
                    )}
                  </div>
                </Box>
              ))}
            </div>
          </Scrollbar>
        </div>
      </div>
    </div>
  )
})
